import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap';
import { fetchElementsInitAction } from '../../../../../actions/instances/elements';
import Icon from '../../../../atoms/Icon/Icon';
import './SelectElementModal.scss';

const SelectElementModal = ({
  onItemSelected,
}) => {
  const {
    elements,
    didLoadElements,
    isLoadingElements,
  } = useSelector(state => state.buildingElementInstance);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!didLoadElements && !isLoadingElements) {
      dispatch(fetchElementsInitAction());
    }
  }, []);
  return (
    <div>
      <Row>
        <Col md={12}>
          <Table responsive striped bordered>
            <colgroup>
              <col width="10%" />
              <col width="60%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Dynasty</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {elements.map(element => (
                <tr>
                  <td>{element.code}</td>
                  <td>{`${element.name} [${element.code}]`}</td>
                  <td>{`${element.dynasty.name} [${element.dynasty.code}]`}</td>
                  <td className="text-center">
                    <Button size="sm" color="light" onClick={() => onItemSelected(element)}>
                      <Icon icon="check" color="#000" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

SelectElementModal.propTypes = {
  onItemSelected: PropTypes.func.isRequired,
};

SelectElementModal.defaultProps = {

};

export default SelectElementModal;
